import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try { await register(name, email, password); navigate('/pricing'); }
    catch (err) { setError(err.response?.data?.detail || 'Registration failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative" style={{ fontFamily: "'Manrope', sans-serif", background: 'linear-gradient(180deg, #0B0F1A 0%, #0E1320 100%)' }}>
      <div aria-hidden="true" className="fixed inset-0 z-0 pointer-events-none opacity-[0.03] mix-blend-overlay" style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`, backgroundRepeat: 'repeat', backgroundSize: '150px' }} />
      <div className="w-full max-w-sm relative z-10">
        <span className="text-base font-medium tracking-tight text-[#F5EDE4] block mb-12">Scriptwriter Pro</span>
        <h2 className="text-3xl font-medium tracking-tight text-[#F5EDE4] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Start writing</h2>
        <p className="text-sm text-[#F5EDE4]/40 mb-10">Create your account and write your first film.</p>
        {error && <p className="text-red-400/80 text-xs mb-6" data-testid="register-error">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-8">
          <div>
            <label className="block text-xs text-[#F5EDE4]/40 uppercase tracking-[0.15em] mb-3" style={{ fontFamily: "'JetBrains Mono', monospace" }}>Name</label>
            <input data-testid="register-name" type="text" value={name} onChange={e => setName(e.target.value)} required placeholder="Your name"
              className="w-full bg-transparent border-b border-[#F5EDE4]/[0.08] focus:border-[#D6A85C]/40 outline-none py-3 text-[#F5EDE4] placeholder:text-[#F5EDE4]/20 text-sm transition-colors duration-300" />
          </div>
          <div>
            <label className="block text-xs text-[#F5EDE4]/40 uppercase tracking-[0.15em] mb-3" style={{ fontFamily: "'JetBrains Mono', monospace" }}>Email</label>
            <input data-testid="register-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com"
              className="w-full bg-transparent border-b border-[#F5EDE4]/[0.08] focus:border-[#D6A85C]/40 outline-none py-3 text-[#F5EDE4] placeholder:text-[#F5EDE4]/20 text-sm transition-colors duration-300" />
          </div>
          <div>
            <label className="block text-xs text-[#F5EDE4]/40 uppercase tracking-[0.15em] mb-3" style={{ fontFamily: "'JetBrains Mono', monospace" }}>Password</label>
            <input data-testid="register-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} placeholder="Min 6 characters"
              className="w-full bg-transparent border-b border-[#F5EDE4]/[0.08] focus:border-[#D6A85C]/40 outline-none py-3 text-[#F5EDE4] placeholder:text-[#F5EDE4]/20 text-sm transition-colors duration-300" />
          </div>
          <button data-testid="register-submit" type="submit" disabled={loading}
            className="w-full py-3.5 text-xs font-medium disabled:opacity-20 active:scale-[0.98] transition-all duration-300 flex items-center justify-center gap-2"
            style={{ backgroundColor: '#D6A85C', color: '#0B0F1A' }}>
            {loading && <Loader2 className="h-3 w-3 animate-spin" />} Create account
          </button>
        </form>
        <p className="mt-10 text-xs text-[#F5EDE4]/30">Already have an account? <Link to="/login" className="text-[#D6A85C]/70 hover:text-[#D6A85C] transition-colors duration-300">Sign in</Link></p>
      </div>
    </div>
  );
}
